// extracted by mini-css-extract-plugin
export default {"mainCenter":"podesiIzgledSajta_mainCenter__YNEHD","headerImage":"podesiIzgledSajta_headerImage__MKTd4","blue":"podesiIzgledSajta_blue__hXsB-","red":"podesiIzgledSajta_red__mtj3l"};